var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBmp = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_5",
  enableBackground: "new 0 0 64 64",
  height: 512,
  viewBox: "0 0 64 64",
  width: 512,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m42 2v8h-26v32h-8v-8-32z",
  fill: "#e6e9ed"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52 51v7h-14v-16h-22v-32h26 2v4h-24v24h16 12v-20h4v15z",
  fill: "#f0d0b4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52 18h-4-4v-4-4z",
  fill: "#ff826e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 18v-4h-24v24h28v-20z",
  fill: "#e6e9ed"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 20,
  fill: "#fcd770",
  r: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.05 24.81 4.95 13.19h-12l-3.43-6.86 2.38-6.33c.31-.85.88-1.55 1.59-2.04.7-.49 1.56-.77 2.46-.77 1.8 0 3.42 1.12 4.05 2.81z",
  fill: "#37bc9b"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.57 31.14 3.43 6.86h-16l5.11-10.21c.54-1.1 1.66-1.79 2.89-1.79s2.35.69 2.89 1.79z",
  fill: "#5cd6b3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 34v8h-2c-1.1 0-2.1-.45-2.83-1.17-.72-.73-1.17-1.73-1.17-2.83 0-2.21 1.79-4 4-4z",
  fill: "#ffeaa7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61 33-3 9 3 9h-9v-18z",
  fill: "#ffeaa7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38 62h-32c-2.21 0-4-1.79-4-4v-20c0 1.1.45 2.1 1.17 2.83.73.72 1.73 1.17 2.83 1.17h2 8 22v16z",
  fill: "#fcd770"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m59.054 42 3.333-10h-9.387v-14.414l-8.586-8.586h-1.414v-8h-36v32h-1c-2.757 0-5 2.243-5 5v20c0 2.757 2.243 5 5 5h33v-4h14v-7h9.387zm-24.672-5h-12.764l4.382-8.764c.381-.762 1.147-1.236 2-1.236s1.619.474 2 1.236zm2.236 0-2.957-5.914 2.222-5.926c.484-1.292 1.737-2.16 3.117-2.16s2.633.868 3.117 2.16l4.44 11.84zm10.382-4.515-3.01-8.027c-.776-2.068-2.781-3.458-4.99-3.458s-4.214 1.39-4.99 3.458l-1.57 4.186-.651-1.302c-.722-1.445-2.174-2.342-3.789-2.342s-3.067.897-3.789 2.342l-3.211 6.422v-18.764h22v4h4zm-2-15.485v-4.586l4.586 4.586zm-4-14v6h-26v32h-6v-38zm-35 32h1v6h-1c-1.654 0-3-1.346-3-3s1.346-3 3-3zm31 26h-31c-1.654 0-3-1.346-3-3v-16.002c.836.628 1.875 1.002 3 1.002h31zm2-4v-16h-22v-30h26v2h-24v26h30v-20h2v38zm14-23h6.613l-2.667 8 2.667 8h-6.613z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 59h4c2.206 0 4-1.794 4-4 0-1.193-.525-2.267-1.357-3 .832-.733 1.357-1.807 1.357-3 0-2.206-1.794-4-4-4h-4zm2-12h2c1.103 0 2 .897 2 2s-.897 2-2 2h-2zm0 6h2c1.103 0 2 .897 2 2s-.897 2-2 2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 55h1c2.757 0 5-2.243 5-5s-2.243-5-5-5h-3v14h2zm0-8h1c1.654 0 3 1.346 3 3s-1.346 3-3 3h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 49.64 1.246 4.36h3.508l1.246-4.36v9.36h2v-14h-2.754l-2 7h-.492l-2-7h-2.754v14h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m26 17c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm0 4c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 41h8v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 45h8v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 49h8v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m41 53h8v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11 5h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 5h24v2h-24z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBmp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bmp.eb59ed55b68928b27e96d14468a84e17.svg";